import { Component } from "@angular/core";
import { ProductGeneralComponent } from "../../../merchandize/merchandize-detail/general/product-general.component";

@Component({
    selector: 'op-general',
    templateUrl: './general.component.html'
})
export class GeneralComponent extends ProductGeneralComponent {

}